import styled from "@emotion/styled";

const SelectField:any = styled.select`
    color: ${(props:any) => (props.error ? '#ED3257 !important' : 'inherit !important')};
    border-color: ${(props:any) => (props.error ? '#ED3257 !important' : 'inherit !important')};
`

export default SelectField